module.exports = __webpack_public_path__ + "static/media/icon_mypage_person.4579fc00.svg";